// src/components/MultiStepForm/index.js

import React, { useEffect, useRef } from "react";
import { useFormContext } from "../../context/FormContext";

const MultiStepForm = ({ steps, onSubmit, onCancel, history, redirectPath, onNext }) => {
  const {
    currentStepIndex,
    formData,
    nextStep,
    prevStep,
    updateFormData,
  } = useFormContext();

  const currentStep = steps[currentStepIndex];
  const isSubmissionStep = currentStep?.isSubmissionStep || false;
  const isLastStep = currentStepIndex === steps.length - 1;
  const isRedirectStep = currentStep?.isRedirectStep || false;

  // Initialize formData = initialValues only once
  const hasInitialized = useRef(false);
  useEffect(() => {
    if (!hasInitialized.current) {
      const currentInitialValues = currentStep?.initialValues || {};
      updateFormData(currentInitialValues); // Override formData
      hasInitialized.current = true;
    }
  }, [currentStep, updateFormData]);

  const handleNext = async (values) => {
    updateFormData(values);

    if (isRedirectStep) {
      history.push(redirectPath);
      return;
    }

    if (isSubmissionStep) {
      try {
        await onSubmit({ ...formData, ...values }, nextStep);
        onNext(values, nextStep, currentStep);
        return;
      } catch (error) {
        console.error("Submission error:", error);
        return;
      }
    }else{
      if (onNext) {
        // awaited so FormStep keeps its buttons disabled during async checks (a second click would advance twice)
        await onNext(values, nextStep, currentStep);
        return;
      }
    }

    if (!isLastStep) {
      nextStep();
    }
  };

  const handleBack = () => {
    prevStep();
  };

  const handleCancel = () => {
    onCancel(currentStep);
  };

  return (
    <div>
      {React.cloneElement(currentStep?.component, {
        initialValues: { ...formData }, // Always pass formData
        validationSchema: currentStep?.validationSchema,
        onNext: handleNext,
        onBack: currentStepIndex > 0 ? handleBack : null,
        onCancel: handleCancel,
      })}
    </div>
  );
};

export default MultiStepForm;